import { render, staticRenderFns } from "./bs-form-group.vue?vue&type=template&id=5013e5b6&scoped=true"
import script from "./bs-form-group.vue?vue&type=script&lang=ts"
export * from "./bs-form-group.vue?vue&type=script&lang=ts"
import style0 from "./bs-form-group.vue?vue&type=style&index=0&id=5013e5b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5013e5b6",
  null
  
)

export default component.exports